module.exports = __webpack_public_path__ + "static/media/tips_button.df7f4007.mp3";